import http from '../../services/http-common';

class CompanyService {
  getAll() {
    return http.get('/bearerToken');
  }
  getCompanyForList() {
    return http.get('/bearerToken');
  }
  
  update(companyID, data) {
    // console.log('company insert typeId:', typeId);
    console.log('company insert value:', data);
    return http.put(`/bearerToken/updateCompany`, data);
    // return http.post(`/company/${typeId}/add`, value);    
  }
}

export default new CompanyService();
